// extracted by mini-css-extract-plugin
export default {"backgroundImage":"styles_backgroundImage__kkvIU","wrapper":"styles_wrapper__mrrMk","footer":"styles_footer__NaTvF"};